/* Spicy Candy x Dawn — effets modernes + avis Google + sticky ATC + cart bounce + barre livraison offerte */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  var css = [
    '.button{position:relative;overflow:hidden;}',
    '.button::before{content:"";position:absolute;top:0;left:-120%;width:80%;height:100%;background:linear-gradient(120deg,transparent 0%,rgba(255,255,255,.45) 50%,transparent 100%);transform:skewX(-20deg);transition:left 650ms cubic-bezier(.4,0,.2,1);z-index:0;pointer-events:none;}',
    '.button:hover::before{left:140%;}',
    '.sc-reveal{opacity:0;transform:translateY(2.4rem);transition:opacity .7s cubic-bezier(0,0,.2,1),transform .7s cubic-bezier(0,0,.2,1);will-change:opacity,transform;}',
    '.sc-reveal.sc-in{opacity:1;transform:none;}',
    '.card__media>.media img,.card__media img{width:116%!important;height:116%!important;top:-8%!important;left:-8%!important;max-width:none!important;}',
    '.sc-progress{position:fixed;top:0;left:0;height:3px;width:0;background:var(--sc-cinnamon,#FF4500);z-index:200;transition:width 80ms linear;pointer-events:none;}',
    '.sc-totop{position:fixed;bottom:2rem;left:2rem;z-index:99;width:4.6rem;height:4.6rem;border:0;border-radius:9999px;background:var(--sc-cinnamon,#FF4500);color:#fff;display:inline-flex;align-items:center;justify-content:center;box-shadow:0 8px 24px rgba(42,24,16,.22);cursor:pointer;opacity:0;visibility:hidden;transform:translateY(12px);transition:opacity .25s,transform .25s,background .15s,bottom .3s;}',
    '.sc-totop.is-visible{opacity:1;visibility:visible;transform:translateY(0);}',
    '.sc-totop:hover{background:var(--sc-cinnamon-dark,#D13A00);transform:translateY(-3px);}',
    '.sc-totop svg{width:2rem;height:2rem;}',
    '.scrb{position:fixed;right:2rem;bottom:2rem;z-index:95;width:min(31rem,calc(100vw - 4rem));background:#fff;border-radius:1.6rem;box-shadow:0 14px 44px rgba(42,24,16,.22);overflow:hidden;opacity:0;transform:translateY(18px);transition:opacity .4s,transform .4s,bottom .3s;pointer-events:none;}',
    '.scrb.is-shown{opacity:1;transform:none;pointer-events:auto;}',
    '.scrb__bar{display:block!important;height:1rem;width:100%;background:var(--sc-cinnamon,#FF4500);}',
    '.scrb__close{position:absolute;top:1.4rem;right:1rem;width:2.6rem;height:2.6rem;border:0;background:transparent;color:#9a8b7b;cursor:pointer;font-size:2rem;line-height:1;border-radius:50%;display:flex;align-items:center;justify-content:center;}',
    '.scrb__close:hover{background:#f1ece4;color:#2A1810;}',
    '.scrb__body{display:flex;align-items:center;gap:1.3rem;padding:1.5rem 1.7rem 1.7rem;}',
    '.scrb__av{width:5rem;height:5rem;border-radius:50%;background:#fff;border:1px solid #ECE7DC;display:flex;align-items:center;justify-content:center;flex:0 0 auto;box-shadow:0 1px 4px rgba(42,24,16,.1);}',
    '.scrb__av svg{width:2.9rem;height:2.9rem;}',
    '.scrb__info{min-width:0;transition:opacity .4s;}',
    '.scrb.is-fading .scrb__info{opacity:0;}',
    '.scrb__title{font-weight:700;color:#2A1810;font-size:1.5rem;line-height:1.2;}',
    '.scrb__rate{display:flex;align-items:center;gap:.5rem;margin-top:.3rem;}',
    '.scrb__stars{color:#FBB000;font-size:1.6rem;letter-spacing:.06em;line-height:1;}',
    '.scrb__cnt{font-size:1.2rem;color:#6B5E50;margin-top:.25rem;}',
    '.sc-satc{position:fixed;left:0;right:0;bottom:0;z-index:101;background:#fff;border-top:1px solid #E8E0D4;box-shadow:0 -6px 20px rgba(42,24,16,.12);display:flex;align-items:center;gap:1.6rem;padding:1rem 1.6rem;transform:translateY(115%);transition:transform .3s ease;}',
    '.sc-satc.is-shown{transform:none;}',
    '.sc-satc__info{flex:1;min-width:0;display:flex;flex-direction:column;}',
    '.sc-satc__t{font-weight:700;font-size:1.35rem;color:#2A1810;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:1.2;}',
    '.sc-satc__p{font-size:1.3rem;color:#D13A00;font-weight:800;}',
    '.sc-satc__btn{background:var(--sc-cinnamon,#FF4500);color:#fff;border:0;border-radius:9999px;padding:1.2rem 2.6rem;font-weight:700;text-transform:uppercase;letter-spacing:.08em;cursor:pointer;font-family:var(--font-heading-family);white-space:nowrap;transition:background .15s,transform .15s;}',
    '.sc-satc__btn:hover{background:var(--sc-cinnamon-dark,#D13A00);transform:translateY(-1px);}',
    '.sc-satc__btn[disabled]{background:#9a8b7b;cursor:not-allowed;}',
    'body.sc-atc-open .scrb{bottom:9rem;}',
    'body.sc-atc-open .sc-totop{bottom:9rem;}',
    '.sc-ship{padding:.4rem 0 1.6rem;}',
    '.sc-ship__msg{font-size:1.35rem;line-height:1.4;margin:0 0 .8rem;color:#2A1810;text-align:center;}',
    '.sc-ship__msg strong{color:var(--sc-cinnamon,#FF4500);}',
    '.sc-ship__track{height:.8rem;background:rgba(42,24,16,.12);border-radius:9999px;overflow:hidden;}',
    '.sc-ship__fill{height:100%;background:linear-gradient(90deg,#FF4500,#D13A00);border-radius:9999px;transition:width .4s ease;min-width:.6rem;}',
    '@keyframes scBounce{0%,100%{transform:scale(1);}30%{transform:scale(1.35);}55%{transform:scale(.88);}75%{transform:scale(1.08);}}',
    '.sc-bounce{animation:scBounce .55s ease;}',
    '@media (max-width:749px){.scrb{right:1rem;bottom:1rem;width:calc(100vw - 2rem);max-width:30rem;}.sc-totop{bottom:1.4rem;left:1.4rem;width:4.2rem;height:4.2rem;}body.sc-atc-open .scrb{bottom:8.5rem;}body.sc-atc-open .sc-totop{bottom:8.5rem;}}',
    '@media (prefers-reduced-motion:reduce){.sc-reveal{opacity:1!important;transform:none!important;}.button::before{display:none;}.sc-bounce{animation:none;}.scrb__info{transition:none;}}'
  ].join('');
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function initStickyHeader() {
    var header = document.querySelector('.header-wrapper, .header');
    if (!header) return;
    var raf = null;
    function u(){ raf = null; header.classList.toggle('is-scrolled', (window.pageYOffset || document.documentElement.scrollTop) > 20); }
    window.addEventListener('scroll', function(){ if (raf === null) raf = requestAnimationFrame(u); }, { passive: true });
    u();
  }

  function initReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var nodes = document.querySelectorAll('.card-wrapper, .multicolumn-list__item, .collection-list__item');
    if (!nodes.length) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('sc-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    var vh = window.innerHeight;
    nodes.forEach(function(el, i){
      if (el.getBoundingClientRect().top < vh) { el.classList.add('sc-reveal', 'sc-in'); return; }
      el.classList.add('sc-reveal');
      el.style.transitionDelay = ((i % 4) * 90) + 'ms';
      io.observe(el);
    });
  }

  function initProgress() {
    var bar = document.createElement('div');
    bar.className = 'sc-progress';
    document.body.appendChild(bar);
    var raf = null;
    function u(){
      raf = null;
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var pct = max > 0 ? ((h.scrollTop || window.pageYOffset) / max * 100) : 0;
      bar.style.width = pct + '%';
    }
    window.addEventListener('scroll', function(){ if (raf === null) raf = requestAnimationFrame(u); }, { passive: true });
    u();
  }

  function initToTop() {
    var btn = document.createElement('button');
    btn.className = 'sc-totop';
    btn.setAttribute('aria-label', 'Retour en haut');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    btn.addEventListener('click', function(){ window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    document.body.appendChild(btn);
    var raf = null;
    function u(){ raf = null; btn.classList.toggle('is-visible', (window.pageYOffset || document.documentElement.scrollTop) > 500); }
    window.addEventListener('scroll', function(){ if (raf === null) raf = requestAnimationFrame(u); }, { passive: true });
    u();
  }

  function initReviewBadge() {
    try { if (sessionStorage.getItem('scrbClosed')) return; } catch (e) {}
    var gsvg = "<svg viewBox='0 0 48 48'><path fill='#EA4335' d='M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z'/><path fill='#4285F4' d='M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z'/><path fill='#FBBC05' d='M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z'/><path fill='#34A853' d='M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z'/></svg>";
    var reviews = [
      { n: 'Christine A.', d: 'il y a 2 mois' },
      { n: 'Margaux', d: 'il y a 3 mois' },
      { n: 'Sanaa H.', d: 'il y a 3 mois' },
      { n: 'Stéphanie G.', d: 'il y a 3 mois' },
      { n: 'Dorian S.', d: 'il y a 4 mois' },
      { n: 'Audrey G.', d: 'il y a 5 mois' },
      { n: 'Sylvette B.', d: 'il y a 5 mois' },
      { n: 'Fanny V.', d: 'il y a 5 mois' },
      { n: 'Yann M.', d: 'il y a 6 mois' }
    ];
    var idx = 0;
    var el = document.createElement('div');
    el.className = 'scrb';
    el.setAttribute('aria-label', 'Avis Google');
    el.innerHTML = "<div class='scrb__bar'></div><button class='scrb__close' aria-label='Fermer'>&times;</button><div class='scrb__body'><div class='scrb__av'>" + gsvg + "</div><div class='scrb__info'><div class='scrb__title'></div><div class='scrb__rate'><span class='scrb__stars'>★★★★★</span></div><div class='scrb__cnt'></div></div></div>";
    document.body.appendChild(el);
    var titleEl = el.querySelector('.scrb__title');
    var cntEl = el.querySelector('.scrb__cnt');
    function render() { var r = reviews[idx]; titleEl.textContent = 'par ' + r.n; cntEl.textContent = r.d + ' · Avis Google'; }
    render();
    var timer = null;
    el.querySelector('.scrb__close').addEventListener('click', function () { el.classList.remove('is-shown'); if (timer) clearInterval(timer); try { sessionStorage.setItem('scrbClosed', '1'); } catch (e) {} });
    setTimeout(function () { el.classList.add('is-shown'); }, 3000);
    if (!reduce) { timer = setInterval(function () { el.classList.add('is-fading'); setTimeout(function () { idx = (idx + 1) % reviews.length; render(); el.classList.remove('is-fading'); }, 400); }, 4500); }
  }

  function initCartBounce() {
    if (reduce || designMode) return;
    var header = document.querySelector('.header');
    if (!header) return;
    function getCount(){ var b = document.querySelector('.cart-count-bubble'); if(!b) return 0; var n = b.textContent.replace(/[^0-9]/g,''); return parseInt(n,10) || 0; }
    var last = getCount();
    var mo = new MutationObserver(function(){
      var c = getCount();
      if (c > last) { var ic = document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icon--cart'); if (ic) { ic.classList.remove('sc-bounce'); void ic.offsetWidth; ic.classList.add('sc-bounce'); } }
      last = c;
    });
    mo.observe(header, { subtree: true, childList: true, characterData: true });
  }

  function initStickyAtc() {
    if (designMode || !('IntersectionObserver' in window)) return;
    var realBtn = document.querySelector('.product__info-container .product-form__submit') || document.querySelector('.product-form__buttons .product-form__submit');
    var titleEl = document.querySelector('.product__title');
    if (!realBtn || !titleEl) return;
    var hEl = document.querySelector('.product__title h1, .product__title h2, .product__title .h1') || titleEl;
    var title = (hEl.textContent || '').replace(/\s+/g, ' ').trim().replace(/^(.+?)\s+\1$/, '$1').trim();
    var priceItem = document.querySelector('.product__info-container .price .price-item--sale');
    if (!priceItem || !priceItem.offsetParent) priceItem = document.querySelector('.product__info-container .price .price-item--regular');
    var price = priceItem ? (priceItem.textContent || '').replace(/\s+/g,' ').trim() : '';
    var bar = document.createElement('div');
    bar.className = 'sc-satc';
    bar.innerHTML = "<div class='sc-satc__info'><span class='sc-satc__t'></span><span class='sc-satc__p'></span></div><button type='button' class='sc-satc__btn'>Ajouter au panier</button>";
    bar.querySelector('.sc-satc__t').textContent = title;
    bar.querySelector('.sc-satc__p').textContent = price;
    var sbtn = bar.querySelector('.sc-satc__btn');
    if (realBtn.disabled) { sbtn.disabled = true; sbtn.textContent = 'Épuisé'; }
    document.body.appendChild(bar);
    sbtn.addEventListener('click', function(){ if (!realBtn.disabled) realBtn.click(); });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ var show = !e.isIntersecting && e.boundingClientRect.top < 0; bar.classList.toggle('is-shown', show); document.body.classList.toggle('sc-atc-open', show); });
    }, { threshold: 0 });
    io.observe(realBtn);
  }

  function initShipBar() {
    if (designMode) return;
    var THRESHOLD = 69;
    function parseMoney(txt){ if(!txt) return 0; var m = txt.replace(/[^0-9.,]/g,'').replace(/\.(?=\d{3}(\D|$))/g,'').replace(',', '.'); var v = parseFloat(m); return isNaN(v)?0:v; }
    var drawer = document.querySelector('#CartDrawer') || document.querySelector('cart-drawer');
    if(!drawer) return;
    var mo = null, lastHTML = '';
    function update(){
      var footer = document.querySelector('.cart-drawer__footer');
      var totalEl = document.querySelector('.totals__total-value');
      if(!footer || !totalEl) return;
      var total = parseMoney(totalEl.textContent);
      var pct = Math.min(100, Math.round(total / THRESHOLD * 100));
      var rem = Math.max(0, THRESHOLD - total);
      var msg = total >= THRESHOLD
        ? '🎉 Bravo, vous bénéficiez de la <strong>LIVRAISON OFFERTE</strong> !'
        : 'Plus que <strong>' + rem.toFixed(2).replace('.', ',') + ' €</strong> pour la <strong>LIVRAISON OFFERTE</strong> 🚚';
      var html = "<p class='sc-ship__msg'>" + msg + "</p><div class='sc-ship__track'><div class='sc-ship__fill' style='width:" + pct + "%'></div></div>";
      var bar = footer.querySelector('.sc-ship');
      if (bar && html === lastHTML) return;
      lastHTML = html;
      if (mo) mo.disconnect();
      if(!bar){ bar = document.createElement('div'); bar.className = 'sc-ship'; footer.insertBefore(bar, footer.firstChild); }
      bar.innerHTML = html;
      if (mo) mo.observe(drawer, { subtree: true, childList: true });
    }
    update();
    mo = new MutationObserver(function(){ update(); });
    mo.observe(drawer, { subtree: true, childList: true });
  }

  function boot(){ initStickyHeader(); initReveal(); initProgress(); initToTop(); initReviewBadge(); initCartBounce(); initStickyAtc(); initShipBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
